import BenchlingConfig from 'BenchlingConfig';
// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import EditorRoutes from 'foundation/EditorRoutes';
import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';
// @ts-expect-error
import AdminAggregateView from 'useradmin/AdminAggregateView';
import AdminLogView from 'useradmin/AdminLogView';
import AdminProjectsDashboardClass from 'useradmin/AdminProjectsDashboard';
import AdminUsersDashboardClass from 'useradmin/AdminUsersDashboard';
import {renderReactComponent} from 'util/RootReactRender';

export const UseradminRoutes: RouteBundle = {
  domain: 'useradmin',
  routes: [
    {urlPattern: '(:currentUserUrl/)admin/activity', handler: useradminActivity, legacy: true},
    {
      urlPattern: ':currentUserUrl/admin/projects_dashboard/',
      handler: useradminProjectsDashboard,
      legacy: true,
    },
    {urlPattern: ':currentUserUrl/admin/users_dashboard/', handler: useradminUsersDashboard, legacy: true},
  ],
};

function useradminActivity(): void {
  DatadogUtil.startRUMView('user_admin_activity');
  new AdminLogView().render();
  if (
    BenchlingConfig.ENABLE_LEGACY_ADMIN_DASHBOARD_PAGES &&
    BenchlingConfig.AUDITING_ENABLE_AGGREGATE_ACTIVITY
  ) {
    new AdminAggregateView().render();
  }
}

function useradminProjectsDashboard(): void {
  DatadogUtil.startRUMView('user_admin_projects_dashboard');
  renderReactComponent(AdminProjectsDashboardClass);
}

function useradminUsersDashboard(): void {
  DatadogUtil.startRUMView('user_admin_users_dashboard');
  renderReactComponent(AdminUsersDashboardClass);
}
